module.exports = __webpack_public_path__ + "images/b983f4a238e8cf89d85acd28d561abc0-paint_stroke.png";